import React from 'react';
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Flex,
  Card,
  CardBody,
} from '@chakra-ui/react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const DashboardLicencias = () => {
  // Datos simulados
  const licencias = [
    { estatus: 'Activa', monto: 1200 },
    { estatus: 'Activa', monto: 1000 },
    { estatus: 'Suspendida', monto: 0 },
    { estatus: 'En revisión', monto: 800 },
    { estatus: 'En revisión', monto: 900 },
    { estatus: 'Suspendida', monto: 0 },
  ];

  const total = licencias.length;
  const activas = licencias.filter(l => l.estatus === 'Activa').length;
  const suspendidas = licencias.filter(l => l.estatus === 'Suspendida').length;
  const revision = licencias.filter(l => l.estatus === 'En revisión').length;
  const totalIngresos = licencias.reduce((acc, curr) => acc + curr.monto, 0);
  const cumplimiento = Math.round((activas / total) * 100);

  const chartData = [
    { name: 'Activas', value: activas },
    { name: 'En revisión', value: revision },
    { name: 'Suspendidas', value: suspendidas },
  ];

  const colors = ['#38A169', '#ED8936', '#E53E3E'];

  return (
    <Box p={6}>
      {/* <Text fontSize="2xl" fontWeight="bold" mb={4} color="#A1263D">
        Dashboard de Licencias
      </Text> */}

      <Flex gap={6} direction={{ base: 'column', md: 'row' }}>
        {/* Métricas */}
        <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total de Licencias</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Activas</StatLabel>
            <StatNumber>{activas}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>En Revisión</StatLabel>
            <StatNumber>{revision}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Suspendidas</StatLabel>
            <StatNumber>{suspendidas}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total Ingresos</StatLabel>
            <StatNumber>${totalIngresos}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Cumplimiento (%)</StatLabel>
            <StatNumber>{cumplimiento}%</StatNumber>
          </Stat>
        </SimpleGrid>

        {/* Gráfica */}
        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="md">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Estatus de Licencias
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>
    </Box>
  );
};

export default DashboardLicencias;
